export default "__VITE_ASSET__CC7HTUIi__"